module.exports = __webpack_public_path__ + "static/media/oel_favicon.778a6988.png";